type FollowUserEventArgs = {
  userId: number
  isFollowEvent: boolean
}

type FollowUserEventExtra = {
  user_id: number
}

export const followUserEvent = ({ userId, isFollowEvent }: FollowUserEventArgs) => {
  const eventName = isFollowEvent ? 'user.follow_user' : 'user.unfollow_user'

  const extra: FollowUserEventExtra = {
    user_id: userId,
  }

  return {
    event: eventName,
    extra,
  }
}
